angular.module('unica_user.user_controllers')

.controller('UserListController', function(
	$rootScope, $scope, $state, $http,
	$uibModal,
	UserListService, UserDeleteService,
	$confirm
) {
	$scope.userList = [];
	$scope.limit  = 50;
	$scope.offset = 0;
	$scope.canLoad = true;

	$scope.loadUsers = function() {
		$scope.showLoader();
		$scope.canLoad = false;
		UserListService.list($scope.limit, $scope.offset)
			.then(function(data) {
				$scope.hideLoader();

				if (!data.error) {
					$scope.userList = $scope.userList.concat( data );
					if ( data.length == 0 ) {
						$scope.canLoad = false;
					} else {
						$scope.canLoad = true;
						$scope.offset = $scope.offset + data.length;
					}
				} else {
					$rootScope.manageError(data);
				}

			});
	};

	$scope.loadUsers();


	$scope.asyncSelected = undefined;
	$scope.ibNoResults = false;
	$scope.loadingUsers = false;
	$scope.searchUser = function(search) {
		$scope.loadingUsers = true;

		$scope.resetAdvancedSearch( false );

		UserListService
			.search(search)
			.then(function(data) {
				$scope.loadingUsers = false;
				$scope.canLoad = false;
				if ( data.length > 0 ) {
					$scope.ibNoResults = false;
					$scope.userList = data;
					return data;
				} else {
					$scope.userList = [];
					$scope.ibNoResults = true;
					return null;
				}
			});
	};


	$scope.asyncAdv = {};
	$scope.ibNoResultsAdv = false;
	$scope.loadingUsersAdv = false;
	$scope.searchUserAdv = function(search) {
		$scope.loadingUsersAdv = true;
		$scope.ibNoResultsAdv = false;
		UserListService
			.simpleAdvancedSearch($scope.asyncAdv)
			.then(function(data) {
				$scope.loadingUsersAdv = false;
				$scope.canLoad = false;
				if ( data.length > 0 ) {
					$scope.ibNoResultsAdv = false;
					$scope.userList = data;
					return data;
				} else {
					$scope.userList = [];
					$scope.ibNoResultsAdv = true;
					return null;
				}
			});
	};

	$scope.resetAdvancedSearch = function( forceReload ) {
		$scope.asyncAdv = {};
		$scope.loadingUsersAdv = false;
		$scope.ibNoResultsAdv = false;

		if ( forceReload ) {
			$scope.canLoad = true;
			$scope.offset = 0;
			$scope.userList = [];
			$scope.loadUsers();
		}
	}


	$scope.openImportUsersModal = function() {
		var modalInstance = $uibModal.open({
			ariaLabelledBy:  'modal-title',
			ariaDescribedBy: 'modal-body',
			controller:      'ModalImportUsersController',
			controllerAs:    '$ctrl',
			templateUrl:     './templates/modals/import-users.html',
			size:            'lg',
			windowClass:     'modal-users-list'
		});

		modalInstance.result.then(function (data) {
			console.log( data );
			if ( data.result === 'ok' ) {
				$successMsg = 'Operazione completata. Sono stati importati ' + data.imported + '. ';
				if ( data.skipped.length > 0 ) {
					$successMsg += 'Sono stati saltati i seguenti utenti: ' + data.skipped.join(', ');
				}
				$rootScope.showSuccessMsg( $successMsg );

				$scope.loadUsers();
			} else if ( data.result === 'ko' ) {
				$rootScope.showErrorMsg(data.errors);
			}
		}, function () { });
	}


	$scope.$watch('asyncSelected', function() {
		if ( $scope.asyncSelected !== undefined && $scope.asyncSelected.length == 0 ) {
			$scope.canLoad = true;
			$scope.offset = 0;
			$scope.userList = [];
			$scope.loadUsers();
		}
	});

	$scope.showAdvancedSearch = false;
	$scope.toggleAdvancedSearch = function() {
		$scope.showAdvancedSearch = !$scope.showAdvancedSearch;
		$scope.loadingUsers = false;
		$scope.ibNoResults = false;
		$scope.loadingUsersAdv = false;
		$scope.ibNoResultsAdv = false;
	}


	$scope.deleteUser = function(userId) {

		$confirm({
			title: 'Sei sicuro di voler eliminare l\'utente?',
			text: 'Confermi la cancellazione dell\'utente?'
		}).then(function() {

			$scope.showLoader();
			UserDeleteService
				.delete(userId)
				.then(function(data) {
					$scope.hideLoader();

					if (!data.error) {
						angular.forEach($scope.userList, function(user, key) {
							if ( user.id == userId ) {
								$scope.userList.splice(key, 1);
							}
						});
						$scope.showSuccessMsg('Utente eliminato con successo!', '');
					} else {
						$rootScope.manageError(data);
					}

				});

		}, function() {
			// Cancel
		});

	};


	$scope.restoreUser = function(userId) {

		$confirm({
			title: 'Sei sicuro di voler riattivare l\'utente?',
			text: 'Confermi la riattivazione dell\'utente?'
		}).then(function() {

			$scope.showLoader();
			UserDeleteService
				.restore(userId)
				.then(function(data) {
					$scope.hideLoader();

					if (!data.error) {
						angular.forEach($scope.userList, function(user, key) {
							if ( user.id == userId ) {
								$scope.userList[key].status = 1;
							}
						});
						$scope.showSuccessMsg('Utente riattivato con successo!', '');
					} else {
						$rootScope.manageError(data);
					}

				});

		}, function() {
			// Cancel
		});

	};

})

	.controller('ModalImportUsersController',
		function (
			$scope, $stateParams,
			$uibModalInstance, FileUploader, getBaseApiURL, Session
		) {


			$scope.importUsersData = {
				csv: ''
			};


			$scope.formInvalid = true;


			$scope.uploader = new FileUploader({
				removeAfterUpload: true,
				alias: 'csv',
				url: getBaseApiURL + '/import/users',
				headers: {
					Authorization : 'Bearer ' + Session.token,
					Accept: 'application/json'
				}
			});


			$scope.uploader.onAfterAddingFile = function( fileItem ) {
				$scope.formInvalid = false;
			};


			$scope.uploader.onCompleteItem = function(fileItem, response) {
				$scope.hideLoader();
				$uibModalInstance.close( response );
			};


			$scope.deleteImportUsersCsv = function() {
				angular.element(document.querySelector('.users_csv')).val(null);
			};


			$scope.importUsers = function () {
				$scope.showLoader();
				$scope.uploader.uploadAll();
			};


			$scope.closeModal = function() {
				$uibModalInstance.dismiss('cancel');
			};

		})

;